import {TOKENS} from '../../tokens'

export const toggle = {
  dark: {
    selectedBg: TOKENS.dark.positive_500,
    selectedBgHover: TOKENS.dark.positive_700,
    selectedBgDisabled: TOKENS.dark.positive_900,
    selectedBorder: TOKENS.dark.positive_500,
    selectedBorderHover: TOKENS.dark.positive_700,
    selectedBorderDisabled: TOKENS.dark.positive_900,
    unselectedBg: TOKENS.dark.contrast_25,
    unselectedBgHover: TOKENS.dark.contrast_50,
    unselectedBorder: TOKENS.dark.contrast_100,
    unselectedBorderHover: TOKENS.dark.contrast_200,
    disabledBg: TOKENS.dark.contrast_100,
    disabledBorder: TOKENS.dark.contrast_400,
    switchUnselectedBg: TOKENS.dark.contrast_200,
    switchUnselectedBgHover: TOKENS.dark.contrast_100,
    switchDisabledBg: TOKENS.dark.contrast_50,
    invalidBg: TOKENS.dark.negative_25,
    invalidBorder: TOKENS.dark.negative_300,
    invalidBorderHover: TOKENS.dark.negative_600,
    invalidSelectedBg: TOKENS.dark.negative_500,
    invalidSelectedBgHover: TOKENS.dark.negative_400,
    invalidSwitchBg: TOKENS.dark.negative_200,
    invalidSwitchBgHover: TOKENS.dark.negative_100,
    indicator: TOKENS.dark.white,
  },
  light: {
    selectedBg: TOKENS.light.primary_500,
    selectedBgHover: TOKENS.light.primary_400,
    selectedBgDisabled: TOKENS.light.primary_100,
    selectedBorder: TOKENS.light.primary_500,
    selectedBorderHover: TOKENS.light.primary_400,
    selectedBorderDisabled: TOKENS.light.primary_100,
    unselectedBg: TOKENS.light.contrast_25,
    unselectedBgHover: TOKENS.light.contrast_50,
    unselectedBorder: TOKENS.light.contrast_100,
    unselectedBorderHover: TOKENS.light.contrast_200,
    disabledBg: TOKENS.light.contrast_100,
    disabledBorder: TOKENS.light.contrast_400,
    switchUnselectedBg: TOKENS.light.contrast_200,
    switchUnselectedBgHover: TOKENS.light.contrast_100,
    switchDisabledBg: TOKENS.light.contrast_50,
    invalidBg: TOKENS.light.negative_25,
    invalidBorder: TOKENS.light.negative_300,
    invalidBorderHover: TOKENS.light.negative_600,
    invalidSelectedBg: TOKENS.light.negative_500,
    invalidSelectedBgHover: TOKENS.light.negative_400,
    invalidSwitchBg: TOKENS.light.negative_200,
    invalidSwitchBgHover: TOKENS.light.negative_100,
    indicator: TOKENS.light.white,
  },
} as const
